// extracted by mini-css-extract-plugin
export default {"title":"M--z","warning":"N--z","sizeOptionsLegendText":"O--z"};